// extracted by mini-css-extract-plugin
export default {"lastScanLabel":"fe3VAu_V3eWxkDaLyXMe"};